import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React, { Component } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { NavLink } from "react-router-dom";
import debounce from "lodash.debounce";
import FetchServerData from "../../../../provider/FetchServerData";
import {
  DPTextResetPassword_Url,
  GetTokenData_Url,
} from "../../../../provider/ServiceUrl";
import { withRouter } from "../../../../withRouter";
import dpTextLogo from "../../../../assets/img/dptextLogo.png";
import PtsAlert from "../../ptsAlert/PtsAlert";
import PasswordRequirementsTooltip from "../../passwordRequirementsTooltip/passwordRequirementsTooltip";

export class DPTextResetPasswordViaEmail extends Component {
  constructor(props) {
    super(props);
    const str = new URLSearchParams(window.location.search);
    const token = str.get("token");
    if (token) {
      this.getTokenData(token);
    }

    this.state = {
      password: "",
      confirmPassword: "",
      passwordHelperText: "",
      confirmPasswordHelperText: "",
      error: {
        one: true,
        two: true,
        three: true,
        four: true,
        five: true,
      },
      passwordFocussed: false,
      email: "",
      tid: "",
      verificationCode: "",
      showPassword: false,
      showConfirmPassword: false,
    };
  }

  getTokenData(token) {
    const postObject = {
      token: token,
    };
    FetchServerData.callPostService(GetTokenData_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          const paramters = output.data.paramters;
          this.setState({
            email: paramters?.email,
            tid: paramters?.tid,
            verificationCode: paramters?.verificationCode,
          });
        }
      }
    );
  }

  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }
  debouncedValidatePassword = debounce(
    (password, name) => this.validatePassword(password, name),
    800
  );

  validatePassword = (password, name) => {
    const { confirmPassword } = this.state;
    let one = false,
      two = false,
      three = false,
      four = false,
      five = false,
      confirmPasswordHelperText = "";

    if (password.length < 12) {
      one = true;
    }
    if (!password.match(/[A-Z]/)) {
      two = true;
    }
    if (!password.match(/[a-z]/)) {
      three = true;
    }
    if (!password.match(/\d/)) {
      four = true;
    }
    if (!password.match(/\W/)) {
      five = true;
    }
    if (password !== confirmPassword) {
      confirmPasswordHelperText =
        name === "password" && confirmPassword === ""
          ? ""
          : "Passwords do not match";
    }

    if (one || two || three || four || five) {
      this.setState({
        error: { one: one, two: two, three: three, four: four, five: five },
        confirmPasswordHelperText: confirmPasswordHelperText,
        passwordHelperText: "Password requirements not met",
      });
      return;
    }

    this.setState({
      confirmPasswordHelperText: confirmPasswordHelperText,
      passwordHelperText: "",
    });
  };

  handleClickShowConfirmPassword() {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  }

  handlePasswordChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
    if (name === "password") {
      this.debouncedValidatePassword(value, name);
    } else if (name === "confirmPassword") {
      this.debouncedValidatePassword(this.state.password, name);
    }
  };
  handlePasswordConfirmChange(e) {
    this.setState({ confirmPassword: e.target.value });
  }

  toggleFocusPassword = () => {
    this.setState((prevState) => {
      return { passwordFocussed: !prevState.passwordFocussed };
    });
  };

  resetPasswordViaEmailLinkBackend() {
    if (this.state.password !== this.state.confirmPassword) {
      PtsAlert.error("Password & confirm password must match");
      return;
    }
    const postObject = {
      header: { tid: this.state.tid },
      appuser: {
        email: this.state.email,
        credential: this.state.password,
        temppassword: this.state.verificationCode,
      },
    };
    FetchServerData.callPostService(DPTextResetPassword_Url, postObject).then(
      (response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate({
            pathname: "/dptextSignin",
          });
        } else {
        }
      }
    );
  }

  render() {
    const { error, passwordFocussed } = this.state;
    return (
      <div className="authentication-wrapper authentication-cover">
        <div className="authentication-inner row m-0" id="signIn">
          <header
            id="dptextheader"
            className="fixed-top d-flex align-items-center"
          >
            <div className="container d-flex align-items-center justify-content-between">
              <div className="logo">
                <img
                  src={dpTextLogo}
                  alt=""
                  style={{ width: "auto", height: "60px" }}
                />
              </div>
              <nav id="navbar" className="navbar">
                <ul>
                  <li>
                    <a
                      className="nav-link scrollto"
                      href="/dptextSignin"
                      style={{ color: "#53a5ff" }}
                    >
                      Login
                    </a>
                  </li>
                  <li className="active">
                    <a
                      className="nav-link scrollto"
                      href="/dptextSignup"
                      style={{ color: "#53a5ff" }}
                    >
                      Sign Up
                    </a>
                  </li>
                </ul>
                <i className="bi bi-list mobile-nav-toggle" />
              </nav>
            </div>
          </header>
          <div className="d-flex col-12 col-lg-12 col-xl-12 align-items-center authentication-bg p-sm-5 p-4">
            <div className="w-px-400 mx-auto">
              <ValidatorForm
                ref="form"
                id="formAuthentication"
                className="mb-3"
                onSubmit={this.resetPasswordViaEmailLinkBackend.bind(this)}
              >
                <div className="text-start">
                  <h3>Reset Password</h3>
                  {/* <p>
                    We will send you verification code on mobile and in email
                    to reset your password
                  </p> */}
                </div>
                <div className="mb-3 form-password-toggle">
                  <label className="form-label" htmlFor="multiStepsPass">
                    Enter New Password
                    {this.state.passwordHelperText ? (
                      <PasswordRequirementsTooltip
                        error={error}
                        open={passwordFocussed}
                        style={{
                          float: "right",
                          marginTop: "-1em",
                        }}
                      />
                    ) : (
                      ""
                    )}{" "}
                  </label>
                  <div className="input-group input-group-merge">
                    <input
                      type={this.state.showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      className="form-control"
                      aria-describedby="multiStepsPass2"
                      onChange={this.handlePasswordChange.bind(this)}
                      value={this.state.password}
                      onFocus={this.toggleFocusPassword}
                      onBlur={this.toggleFocusPassword}
                      helperText={this.state.passwordHelperText}
                      error={this.state.passwordHelperText !== ""}
                    />
                    <span
                      className="input-group-text cursor-pointer"
                      id="multiStepsPass2"
                      onClick={this.handleClickShowPassword.bind(this)}
                    >
                      {this.state.showPassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </span>
                  </div>
                </div>
                <div className="mb-3 form-password-toggle">
                  <div className="mb-2 form-password-toggle">
                    <label className="form-label" htmlFor="multiStepsPass">
                      Confirm Password
                    </label>
                    <div className="input-group input-group-merge">
                      <input
                        id="confirmPassword"
                        name="confirmPassword"
                        className="form-control"
                        aria-describedby="multiStepsConfirmPass2"
                        value={this.state.confirmPassword}
                        type={this.state.showConfirmPassword ? "text" : "password"}
                        helperText={this.state.confirmPasswordHelperText}
                        error={this.state.confirmPasswordHelperText !== ""}
                        onChange={this.handlePasswordChange.bind(this)}
                      />
                      <span
                        className="input-group-text cursor-pointer"
                        id="multiStepsPass2"
                        onClick={this.handleClickShowConfirmPassword.bind(
                          this
                        )}
                      >
                        {this.state.showConfirmPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </span>
                    </div>
                    {this.state.confirmPasswordHelperText && (
                      <p style={{ color: "red", fontSize: "13px" }}>
                        {this.state.confirmPasswordHelperText}
                      </p>
                    )}
                  </div>
                </div>
                <button className="dptextSiginButton d-grid w-100 mt-2">
                  {" "}
                  Reset Password{" "}
                </button>
              </ValidatorForm>
              <div className="d-flex flex-row">
                <div class="col-ms-4 align-self-start">
                  <NavLink className="pt-1" to="/dptextSignin">
                    <ArrowBackIosNewIcon />
                    Back Sign In
                  </NavLink>
                </div>
                <div class="col-ms-8 align-self-end">
                  <p className="ms-5 ps-4">
                    <span>Need an account?</span>&nbsp;
                    <NavLink to="/dptextSignup">
                      <span>Sign Up</span>
                    </NavLink>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DPTextResetPasswordViaEmail);
